import React from 'react';
import { useParams } from 'react-router';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import { defaultTheme, shouldForwardProp } from '@web-chat-core/ui-kit';
import { ERROR_TYPE } from 'consts';
import { Error } from 'ui/components';
import GlobalStyle from 'ui/globalStyle';

export const ErrorPage: React.FC = () => {
    const { errorType } = useParams<{ errorType?: ERROR_TYPE }>();

    return (
        <StyleSheetManager enableVendorPrefixes shouldForwardProp={shouldForwardProp}>
            <GlobalStyle theme={defaultTheme} />
            <ThemeProvider theme={defaultTheme}>
                <Error errorType={errorType} />
            </ThemeProvider>
        </StyleSheetManager>
    );
};
